import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchConfig } from "./configUtils";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig()
      .then((config) => {
        setConfig(config);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || !config) {
    return null;
  }

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
